<template>
    <div>
        <b-modal id="modal-prevent-closing" no-close-on-backdrop hide-footer
            ref="modal-create-update-group-class-school" @hidden="resetModal">

            <div class="container wrap-form-save-class-school-group">
                <h4>
                    <strong>{{ getNameTitle }}</strong>
                </h4>
                <b-form id="form-change-name-class-school" @submit.prevent="handleSave">
                    <div class="login-modal__form__item display-block">
                        <label for="name">Tên nhóm:</label>
                        <b-form-input id="name" v-model="form.name" type="text" placeholder="Nhập tên nhóm"
                            autocomplete="off"
                            class="form-control display-flex-center form-30h form-bg-gray-light border-rd-20 font-sanpro-light" />
                        <span class="error display-block color-err font-size-14 text-left"
                            v-if="!$v.form.name.required && submitted">
                            Vui lòng điền tên nhóm
                        </span>
                        <!-- <span class="error display-block color-err font-size-14 text-left"
                            v-else-if="!checkNameGroup(form.name)">
                            Tên nhóm đã tồn tại. Vui lòng nhập tên nhóm khác!
                        </span> -->

                    </div>
                    <div class="wrap-list-member">
                        <label for="name">Danh sách học sinh:</label>
                        <div class="row">
                            <div class="col-md-12">
                                <b-form-checkbox-group id="listMember" v-model="form.listMember"
                                    :options="listDataMember" stacked switches
                                    name="listMember"></b-form-checkbox-group>
                            </div>
                        </div>
                    </div>
                    <span class="error display-block color-err font-size-14 text-left"
                        v-if="!$v.form.listMember.required && submitted">
                        Vui lòng chọn học sinh
                    </span>
                    <div class="form_action display-flex justity-content-space-around">
                        <button type="button"
                            class="btn border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading" @click="handleHideModal">
                            Hủy
                        </button>
                        <button type="submit"
                            class="btn btn-main border-rd-20 font-size-16 form-30h font-sanpro-semibold display-flex-center justify-content-center line-height-1"
                            :disabled="isLoading">
                            {{ classSchoolGroupId > 0 ? "Cập nhật" : "Thêm mới" }}
                        </button>
                    </div>
                </b-form>
            </div>

        </b-modal>

    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { getAllMemberInClassSchoolService } from './../_api/classSchoolUserServices'
import { saveClassSchoolGroup, getDetail, checkDuplicate } from './../_api/classSchoolGroupServices'
export default {
    name: "ModalCreateUpdateGroupClassSchool",
    props: {
        classSchoolId: {
            type: Number,
            default: 0
        },
        classSchoolGroupId: {
            type: Number,
            default: 0
        },
        listDataAllGroup: {
            type: Array,
            default: []
        }
    },
    components: {
    },
    watch: {
        classSchoolGroupId() {


        }
    },
    data() {
        return {
            confirmActive: {},
            submitted: false,
            isLoading: false,
            listMemberBeforeUpdate: [],
            listMemberDelete: [],
            form: {
                id: 0,
                name: '',
                listMember: [],
            },
            listDataMember: []
        }
    },
    validations() {
        return {
            form: {
                name: {
                    required,

                },
                listMember: {
                    required
                }
            }
        }
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        getNameTitle() {
            return this.classSchoolGroupId == 0 ? 'Tạo nhóm' : 'Cập nhật nhóm'
        },
    },
    mounted() {
        this.getAllMemberInClassSchool()
        this.handleShowModal()
        if (this.classSchoolGroupId > 0) {
            this.getDetailClassSchoolGroup()
        }
    },

    methods: {
        // check trùng tên nhóm
        checkNameGroup(groupName) {
            // for (let i = 0; i < this.listDataAllGroup.length; i++) {
            //     const nameItemGroup = this.listDataAllGroup[i].name
            //     if (groupName == nameItemGroup) {
            //         return false
            //     }
            // }
            return true
        },
        isContainListMemberBefore(userId) {
            for (let i = 0; i < this.listMemberBeforeUpdate.length; i++) {
                const item = this.listMemberBeforeUpdate[i];
                if (userId == item) {
                    return true
                }
            }
            return false
        },
        isContainListMemberAlter(userId) {
            for (let i = 0; i < this.form.listMember.length; i++) {
                const item = this.form.listMember[i];
                if (userId == item) {
                    return true
                }
            }
            return false
        },
        handleSave() {
            if (this.checkNameGroup(this.form.name)) { // nếu tên nhóm chưa tồn tại
                let self = this
                this.submitted = true
                let listAddNew = []
                let listDelete = []
                //lấy ra list member mới thêm
                for (let i = 0; i < this.form.listMember.length; i++) {
                    const item = this.form.listMember[i];
                    if (!this.isContainListMemberBefore(item)) {
                        listAddNew.push(item)
                    }
                }
                // lấy ra list member xóa
                for (let i = 0; i < this.listMemberBeforeUpdate.length; i++) {
                    const item = this.listMemberBeforeUpdate[i];
                    if (!this.isContainListMemberAlter(item)) {
                        listDelete.push(item)
                    }
                }
                if (!this.$v.$invalid) {
                    checkDuplicate({ id: this.classSchoolGroupId, classSchoolId: this.classSchoolId, name: this.form.name.trim() }).then(res => {
                        let status = res.data
                        if (status == 2) {
                            self.$toast.error('Tên nhóm đã tồn tại')
                        } else {
                            if (this.classSchoolGroupId > 0) {
                                //cập nhật
                                let data = {
                                    id: this.classSchoolGroupId,
                                    classSchoolId: this.classSchoolId,
                                    name: this.form.name.trim(),
                                    listMemberAdd: listAddNew,
                                    listMemberDelete: listDelete
                                }
                                saveClassSchoolGroup(data).then((res) => {
                                    if (res && res.data && !res.errors) {
                                        self.$toast.success('Cập nhật nhóm thành công')
                                        self.handleDone()
                                    }
                                })
                            }
                            else {
                                let data = {
                                    id: this.classSchoolGroupId,
                                    classSchoolId: this.classSchoolId,
                                    name: this.form.name.trim(),
                                    listMemberAdd: this.form.listMember
                                }
                                saveClassSchoolGroup(data).then((res) => {
                                    if (res && res.data && !res.errors) {
                                        self.$toast.success('Tạo mới nhóm thành công')
                                        self.handleDone()
                                    }
                                })
                            }
                        }
                    })

                }
            }
        },
        handleDone() {
            this.handleHideModal()
            this.$emit('handleDone')
        },
        resetModal() {

        },
        toggleModal() {
            // We pass the ID of the button that we want to return focus to
            // when the modal has hidden
            this.$refs['modal-create-update-group-class-school'].toggle('#toggle-btn')
        },
        handleHideModal() {
            //this.$refs['modal-create-update-group-class-school'].hide()
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-create-update-group-class-school'].show()
        },
        getDetailClassSchoolGroup() {
            let self = this
            getDetail(this.classSchoolGroupId).then(res => {
                if (res && res.data && !res.errors) {
                    self.form = {
                        id: res.data.id,
                        name: res.data.name,
                        listMember: res.data.listMemberAdd,
                    }
                    this.listMemberBeforeUpdate = res.data.listMemberAdd
                }
            })
        },
        getAllMemberInClassSchool() {
            this.listDataMember = []
            getAllMemberInClassSchoolService({ classSchoolId: this.classSchoolId, keyword: '', gender: 0 }).then((res) => {
                if (res && res.data && !res.errors) {
                    for (let i = 0; i < res.data.length; i++) {
                        const item = res.data[i];
                        this.listDataMember.push({ text: item.userName, value: item.userId })
                    }
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
.modal-content {
    background-color: red;
}

.wrap-form-save-class-school-group {
    padding-top: 20px;
    background-color: white;

    .wrap-list-member {
        margin-top: 20px;
    }

    #listMember {
        overflow: auto;
        max-height: 200px;
        border-radius: 15px;
        border: 1px solid #cdd4da;
        padding: 5px;
        background: #e5e5e5;
    }
}

.form_action {
    padding-top: 10px;
    margin-top: 40px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}

.justity-content-space-around {
    justify-content: space-around
}
</style>